import React, {useEffect} from 'react'
import AuthWrapper from './AuthWrapper'
import Loader from '../common/Loader'
import {useAppSelector} from '../../store/hooks'
import {selectIsAuthenticated} from '../../store/authSlice'
import {useNavigate, useSearchParams} from 'react-router-dom'

const SignInPage = () => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (isAuthenticated) {
      const redirectParam = searchParams.get('redirect')
      const redirectPath = redirectParam
        ? decodeURIComponent(redirectParam)
        : '/'
      navigate(redirectPath)
    }
  }, [isAuthenticated])

  return (
    <AuthWrapper register={false}>
      <div className="flex justify-center items-center h-screen">
        <Loader text="Signing in..." />
      </div>
    </AuthWrapper>
  )
}

export default SignInPage
